export class Player {
  name: string
  id: string
  bids: Array<Bid>
  constructor(name: string) {
    this.name = name;
  }
}

export class Bid {
  id: string;
  teamId: string;
  time;
  value: number;
  phase: string;

  constructor(teamId: string, time, value: number, phase: string) {
    this.teamId = teamId;
    this.time = time;
    this.value = value;
    this.phase = phase;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/player.ts